module.exports = __webpack_public_path__ + "93adde5d29463b2b21068583fe61bb22.svg";